<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form [formGroup]="callerIdForm" (ngSubmit)="onSubmit()">
    <div class="onsip-grid-placement">
      <div class="second-column">
        <div class="mat-body-1 m-b-10">{{ "ONSIP_I18N.ID_NAME" | translate }}</div>
        <mat-form-field appearance="outline">
          <input matInput formControlName="name" autocomplete="off" />
          @if (callerIdForm.controls['name'].hasError('required')) {
          <mat-error>
            {{ "ONSIP_I18N.NAME_IS_REQUIRED" | translate }}
          </mat-error>
          } @if (callerIdForm.controls['name'].hasError('specialChar')) {
          <mat-error>
            {{ "ONSIP_I18N.NAME_CANNOT_CONTAIN_SPECIAL_CHARACTERS" | translate }}
          </mat-error>
          }
        </mat-form-field>
        <div class="mat-body-1 m-b-10">{{ "ONSIP_I18N.PHONE_NUMBER" | translate }}</div>
        <mat-form-field appearance="outline">
          <input matInput formControlName="phone" autocomplete="off" />
          @if (callerIdForm.controls['phone'].hasError('validPhoneNumber')) {
          <mat-error>
            {{ "ONSIP_I18N.MUST_BE_A_VALID_PHONE_NUMBER" | translate }}
          </mat-error>
          } @if (callerIdForm.controls['phone'].hasError('required')) {
          <mat-error>
            {{ "ONSIP_I18N.PHONE_NUMBER_IS_REQUIRED" | translate }}
          </mat-error>
          }
        </mat-form-field>
        <mat-checkbox color="primary" class="mat-body-1" formControlName="cascade">
          <mat-label class="mat-body-2">{{
            "ONSIP_I18N.APPLY_CALLER_ID_TO_ALL_USERS" | translate
          }}</mat-label>
        </mat-checkbox>
      </div>
      <div class="controls">
        <button mat-button color="primary" class="cancel-btn" type="button" (click)="cancel()">
          {{ "ONSIP_I18N.CANCEL" | translate }}
        </button>
        <button class="submit-btn" mat-flat-button color="primary">
          {{ "ONSIP_I18N.SAVE_CHANGES" | translate }}
        </button>
      </div>
    </div>
  </form>
</onsip-loading-container>
